import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthProvider';

// Route admin — redirige vers 404 si non admin
function PrivateRoute({ children }) {
    const { isLoggedIn, isAdmin } = useAuth();

    if (!isLoggedIn) {
        return <Navigate to="/login" />;
    }

    if (!isAdmin) {
        return <Navigate to="/not-found" />;
    }

    return children;
}

export default PrivateRoute;